// wave4-notif-conform: type -> category mapping, single source of truth. Conforms to the legacy
// Notion spec (page d069715b "Notifications", Alex-and-Q UX board) which requires exactly 5
// selectable categories plus "All notifications":
//   Invitations / Game plan changes / Mentions, replies & nudges / Join Requests /
//   Joins, Likes and Chat
//
// Mapping chosen from the ACTUAL notification `type` enum emitted by the dev backend today
// (grepped api/routers/{participants,gameplan,messages,nudges,coordination_objects}.py +
// api/services/reconciler.py on F:\coowe\wt\wave4-notif-conform-backend):
//   invite, status, suggestion, decide, reaction, happening_soon, happening, ended, mention,
//   reply, nudge, message, removed
// `join_request`/`connect_request` are NOT emitted by any current backend route (no join-request
// notification is wired up yet) -- mapped here anyway so the "Join Requests" category is ready
// the moment that type ships, per the legacy spec's own COOER1 email-template precedent
// (joinRequestNotification.py exists in comms/email_templates but isn't yet dispatched to the
// notifications table).

export const CATEGORY_ALL = "all"
export const CATEGORY_INVITATIONS = "invitations"
export const CATEGORY_GAMEPLAN = "gameplan"
export const CATEGORY_MENTIONS = "mentions"
export const CATEGORY_JOIN_REQUESTS = "join_requests"
export const CATEGORY_JOINS_LIKES_CHAT = "joins_likes_chat"

export const CATEGORIES = [
  { id: CATEGORY_ALL, label: "All notifications" },
  { id: CATEGORY_INVITATIONS, label: "Invitations" },
  { id: CATEGORY_GAMEPLAN, label: "Game plan changes" },
  { id: CATEGORY_MENTIONS, label: "Mentions, replies & nudges" },
  { id: CATEGORY_JOIN_REQUESTS, label: "Join Requests" },
  { id: CATEGORY_JOINS_LIKES_CHAT, label: "Joins, Likes and Chat" },
]

// notification `type` -> category id
export const TYPE_TO_CATEGORY = {
  invite: CATEGORY_INVITATIONS,

  status: CATEGORY_GAMEPLAN,
  suggestion: CATEGORY_GAMEPLAN,
  decide: CATEGORY_GAMEPLAN,
  reaction: CATEGORY_GAMEPLAN,
  happening_soon: CATEGORY_GAMEPLAN,
  happening: CATEGORY_GAMEPLAN,
  ended: CATEGORY_GAMEPLAN,

  task_assigned: CATEGORY_GAMEPLAN,
  task_claimed: CATEGORY_GAMEPLAN,
  task_completed: CATEGORY_GAMEPLAN,
  task_due_soon: CATEGORY_GAMEPLAN,
  reschedule_overdue_evaluated: CATEGORY_GAMEPLAN,
  reschedule_proposed: CATEGORY_GAMEPLAN,

  mention: CATEGORY_MENTIONS,
  reply: CATEGORY_MENTIONS,
  nudge: CATEGORY_MENTIONS,

  join_request: CATEGORY_JOIN_REQUESTS,
  connect_request: CATEGORY_JOIN_REQUESTS,

  message: CATEGORY_JOINS_LIKES_CHAT,
  removed: CATEGORY_JOINS_LIKES_CHAT,
  join: CATEGORY_JOINS_LIKES_CHAT,
  like: CATEGORY_JOINS_LIKES_CHAT,
}

export const categoryForType = type => TYPE_TO_CATEGORY[type] || CATEGORY_JOINS_LIKES_CHAT

// { type: count } (per-type unread, from the backend) -> { categoryId: count } incl. "all" = sum.
export const rollupCountsByCategory = countsByType => {
  const out = {}
  CATEGORIES.forEach(c => {
    out[c.id] = 0
  })
  Object.entries(countsByType || {}).forEach(([type, count]) => {
    const cat = categoryForType(type)
    out[cat] = (out[cat] || 0) + Number(count || 0)
    out[CATEGORY_ALL] = (out[CATEGORY_ALL] || 0) + Number(count || 0)
  })
  return out
}
